/**
 * Gemeinsames Verhalten für Drawer und Modal: öffnen/schließen über einen
 * reaktiven Livewire-Ausdruck, Esc schließt nur das oberste Overlay,
 * Warnung bei ungespeicherten Eingaben (auch beim Verlassen der Seite).
 */
const stack = [];
let seq = 0;

export const anyOverlayOpen = () => stack.length > 0 || window.Alpine?.store('confirm').open;

export function registerOverlay(Alpine) {
    const discardChanges = () =>
        window.nnConfirm({
            title: 'Änderungen verwerfen?',
            text: 'Deine Eingaben wurden noch nicht gespeichert.',
            confirmLabel: 'Verwerfen',
            cancelLabel: 'Weiter bearbeiten',
            tone: 'danger',
        });

    Alpine.data('nnOverlay', (closeMethod) => ({
        open: false,
        dirty: false,
        uid: ++seq,

        init() {
            this._beforeUnload = (event) => {
                if (this.open && this.dirty) {
                    event.preventDefault();
                    event.returnValue = '';
                }
            };
            this._navigate = (event) => {
                if (this.open && this.dirty && !window.confirm('Ungespeicherte Änderungen verwerfen?')) {
                    event.preventDefault();
                }
            };
            window.addEventListener('beforeunload', this._beforeUnload);
            document.addEventListener('livewire:navigate', this._navigate);
        },

        destroy() {
            window.removeEventListener('beforeunload', this._beforeUnload);
            document.removeEventListener('livewire:navigate', this._navigate);
            this.removeFromStack();
        },

        setOpen(value) {
            value = !!value;
            if (value === this.open) return;
            this.open = value;

            if (value) {
                stack.push(this.uid);
                // x-show blendet per setTimeout ein – erst danach fokussieren
                this.$nextTick(() => setTimeout(() => this.$root.querySelector('[autofocus]')?.focus(), 50));
            } else {
                this.dirty = false;
                this.removeFromStack();
            }
        },

        removeFromStack() {
            const index = stack.indexOf(this.uid);
            if (index > -1) stack.splice(index, 1);
        },

        onEscape() {
            if (!this.open || Alpine.store('confirm').open) return;
            if (stack[stack.length - 1] !== this.uid) return;
            // Esc hat gerade eine Auswahlliste (tom-select) geschlossen → Drawer offen lassen
            if (Date.now() - (window.nnSelectClosedAt || 0) < 100) return;
            this.requestClose();
        },

        async requestClose() {
            if (this.dirty && !(await discardChanges())) return;
            this.setOpen(false);
            this.$wire.$call(closeMethod);
        },
    }));
}
